<template>
  <router-link v-if="link" :to="link" class="box-img">
    <q-img
      :src="defaultProductImage(imageSrc)"
      :ratio="1"
      :width="width"
      :height="height"
      fit="contain"
    >
      <template v-slot:loading>
        <q-spinner color="primary" size="1em" :thickness="2" />
      </template>
    </q-img>
  </router-link>
  <div class="box-img" v-else>
    <q-img
      :src="defaultProductImage(imageSrc)"
      :ratio="1"
      :width="width"
      :height="height"
    >
      <template v-slot:loading>
        <q-spinner color="primary" size="1em" :thickness="2" />
      </template>
    </q-img>
  </div>
</template>

<script>
import defaultProductImage from 'src/filters/defaultProductImage'
export default {
  name: 'BoxImage',
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    link: {
      type: [Object, String],
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { defaultProductImage }
  },
}
</script>
